import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, ListResponse } from './types'

import type { ReportEntity } from '../../drilldown/types'

type DepartmentReport = ReportEntity & {
  departmentId: number
  departmentName: string
  departmentCode: string
}
type DDDepartmentResponse = ListResponse<DepartmentReport>

const IS_NEW_BACKEND_API = true

export const getDrillDownDepartments = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const categoryResult = await get<DDDepartmentResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
